{
    "(save {highestYearlyDiscount}%)": "(εξοικονόμηση {highestYearlyDiscount}%)",
    "{amount} days free": "{amount} ημέρες δωρεάν",
    "{amount} off": "{amount} έκπτωση",
    "{amount} off for first {number} months.": "{amount} έκπτωση για τους πρώτους {number} μήνες.",
    "{amount} off for first {period}.": "{amount} έκπτωση για την πρώτη {period}.",
    "{amount} off forever.": "{amount} έκπτωση για πάντα.",
    "{discount}% discount": "{discount}% έκπτωση",
    "{memberEmail} will no longer receive {newsletterName} newsletter.": "Το {memberEmail} δεν θα λαμβάνει πλέον το ενημερωτικό δελτίο {newsletterName}.",
    "{memberEmail} will no longer receive emails when someone replies to your comments.": "Το {memberEmail} δεν θα λαμβάνει πλέον email όταν κάποιος απαντά στα σχόλιά σας.",
    "{memberEmail} will no longer receive this newsletter.": "Το {memberEmail} δεν θα λαμβάνει πλέον αυτό το ενημερωτικό δελτίο.",
    "{memberEmail} will no longer receive updates & announcements.": "",
    "{months} months": "",
    "{months} months free": "",
    "{tierName} membership": "",
    "{trialDays} days free": "{trialDays} ημέρες δωρεάν",
    "{years} years": "",
    "+1 (123) 456-7890": "",
    "1 month": "",
    "1 month free": "",
    "1 year": "",
    "A gift, just for you": "",
    "Access your RSS feeds": "",
    "Account": "Λογαριασμός",
    "Account details updated successfully": "",
    "Account settings": "Ρυθμίσεις λογαριασμού",
    "Add a personal note": "",
    "After a free trial ends, you will be charged the regular price for the tier you've chosen. You can always cancel before then.": "Μετά το τέλος της δωρεάν δοκιμής, θα χρεωθείτε την κανονική τιμή για το επίπεδο που έχετε επιλέξει. Μπορείτε πάντα να ακυρώσετε πριν από τότε.",
    "Already a member?": "Ήδη μέλος;",
    "An error occurred": "",
    "An unexpected error occured. Please try again or <a>contact support</a> if the error persists.": "Παρουσιάστηκε ένα απρόβλεπτο σφάλμα. Δοκιμάστε ξανά ή <a>επικοινωνήστε με την υποστήριξη</a> εάν το σφάλμα παραμένει.",
    "Back": "Πίσω",
    "Back to Log in": "Επιστροφή στη σύνδεση",
    "Before you go": "",
    "Billing info & receipts": "",
    "Black Friday": "Black Friday",
    "Bluesky": "",
    "Cancel anytime.": "Ακύρωση ανά πάσα στιγμή.",
    "Cancel subscription": "Ακύρωση συνδρομής",
    "Canceled": "",
    "Cancellation reason": "Λόγος ακύρωσης",
    "Change": "Αλλαγή",
    "Change plan": "",
    "Check spam & promotions folders": "Ελέγξτε τους φακέλους ανεπιθύμητης αλληλογραφίας και προσφορών",
    "Check with your mail provider": "Ελέγξτε με τον παροχέα email σας",
    "Check your inbox to verify email update": "",
    "Choose": "Επιλέξτε",
    "Choose a different plan": "Επιλέξτε ένα διαφορετικό πρόγραμμα",
    "Choose a plan": "",
    "Choose your newsletters": "Επιλέξτε τα ενημερωτικά δελτία σας",
    "Click here to retry": "Κάντε κλικ εδώ για επανάληψη",
    "Click the confirmation link in your inbox to finish redeeming your membership. If it doesn't arrive within 3 minutes, check your spam folder.": "",
    "Close": "Κλείσιμο",
    "Code": "",
    "Comment preferences updated.": "",
    "Comments": "Σχόλια",
    "Complimentary": "Δωρεάν",
    "Confirm": "Επιβεβαίωση",
    "Confirm cancellation": "Επιβεβαίωση ακύρωσης",
    "Confirm subscription": "Επιβεβαίωση συνδρομής",
    "Contact support": "Επικοινωνήστε με την υποστήριξη",
    "Continue": "Συνέχεια",
    "Continue subscription": "Συνέχεια συνδρομής",
    "Continue with a paid subscription anytime. Your remaining gift period will be added as a free trial.": "",
    "Copied": "",
    "Copy": "",
    "Copy link": "",
    "Could not create Stripe billing portal session": "",
    "Could not create Stripe checkout session": "",
    "Could not sign in. Login link expired.": "Δεν ήταν δυνατή η σύνδεση. Ο σύνδεσμος σύνδεσης έχει λήξει.",
    "Could not update email! Invalid link.": "Δεν ήταν δυνατή η ενημέρωση του email! Μη έγκυρος σύνδεσμος.",
    "Create a new contact": "Δημιουργήστε νέα επαφή",
    "Current plan": "Τρέχον πρόγραμμα",
    "Delete account": "Διαγραφή λογαριασμού",
    "Didn't mean to do this? Manage your preferences <button>here</button>.": "Δεν το εννοούσατε; Διαχειριστείτε τις προτιμήσεις σας <button>εδώ</button>.",
    "Don't have an account?": "Δεν έχετε λογαριασμό;",
    "Edit": "Επεξεργασία",
    "Email": "Email",
    "Email confirmation link expired.": "",
    "Email newsletter": "Ενημερωτικό δελτίο email",
    "Email newsletter settings updated": "",
    "Email preferences": "Προτιμήσεις email",
    "Email preferences updated.": "",
    "Emails": "Emails",
    "Emails disabled": "Τα emails είναι απενεργοποιημένα",
    "Ends {offerEndDate}": "Λήγει {offerEndDate}",
    "Enjoy {amountOff} off forever.": "",
    "Enjoy {months} free months on us.": "",
    "Enjoy {months} free months on us. You won't be charged until {newBillingDate}.": "",
    "Enjoy a free month on us.": "",
    "Enjoy a free month on us. You won't be charged until {newBillingDate}.": "",
    "Enter code above": "",
    "Enter your email address": "",
    "Enter your name": "",
    "Error": "Σφάλμα",
    "Expires {expiryDate}": "Λήγει {expiryDate}",
    "Facebook": "",
    "Failed to cancel subscription, please try again": "",
    "Failed to log in, please try again": "",
    "Failed to log out, please try again": "",
    "Failed to open billing portal, please try again": "",
    "Failed to process checkout, please try again": "",
    "Failed to send magic link email": "",
    "Failed to send verification email": "",
    "Failed to sign up, please try again": "",
    "Failed to update account data": "",
    "Failed to update account details": "",
    "Failed to update billing information, please try again": "",
    "Failed to update newsletter settings": "",
    "Failed to update subscription, please try again": "",
    "Failed to verify code, please try again": "",
    "Forever": "Για πάντα",
    "Free Trial – Ends {trialEnd}": "Δωρεάν Δοκιμή – Λήγει {trialEnd}",
    "Get help": "Λάβετε βοήθεια",
    "Get in touch for help": "Επικοινωνήστε για βοήθεια",
    "Get notified when someone replies to your comment": "Λάβετε ειδοποίηση όταν κάποιος απαντά στο σχόλιό σας",
    "Gift a membership": "",
    "Gift could not be redeemed": "",
    "Gift details": "",
    "Gift redeemed! You're all set.": "",
    "Gift subscription": "",
    "Gift subscriptions are not available right now.": "",
    "Gift value": "",
    "Give feedback on this post": "Δώστε ανατροφοδότηση για αυτήν την ανάρτηση",
    "Help! I'm not receiving emails": "Βοήθεια! Δεν λαμβάνω emails",
    "Here are a few other sites you may enjoy.": "Εδώ είναι μερικοί άλλοι ιστότοποι που μπορεί να σας αρέσουν.",
    "Hide details": "",
    "If a newsletter is flagged as spam, emails are automatically disabled for that address to make sure you no longer receive any unwanted messages.": "Αν ένα ενημερωτικό δελτίο επισημανθεί ως ανεπιθύμητο, τα emails απενεργοποιούνται αυτόματα για αυτήν τη διεύθυνση για να βεβαιωθείτε ότι δεν θα λάβετε πλέον ανεπιθύμητα μηνύματα.",
    "If the spam complaint was accidental, or you would like to begin receiving emails again, you can resubscribe to emails by clicking the button on the previous screen.": "Αν η αναφορά ανεπιθύμητης αλληλογραφίας ήταν κατά λάθος ή θέλετε να αρχίσετε να λαμβάνετε ξανά emails, μπορείτε να εγγραφείτε ξανά κάνοντας κλικ στο κουμπί στην προηγούμενη οθόνη.",
    "If you cancel your subscription now, you will continue to have access until {periodEnd}.": "Αν ακυρώσετε τη συνδρομή σας τώρα, θα συνεχίσετε να έχετε πρόσβαση μέχρι {periodEnd}.",
    "If you have a corporate or government email account, reach out to your IT department and ask them to allow emails to be received from {senderEmail}": "Αν έχετε εταιρικό ή κυβερνητικό λογαριασμό email, επικοινωνήστε με το τμήμα IT και ζητήστε τους να επιτρέψουν την παραλαβή emails από {senderEmail}",
    "If you have an account, a login link has been sent to your inbox. If it doesn't arrive in 3 minutes, be sure to check your spam folder.": "Ένας σύνδεσμος σύνδεσης έχει σταλεί στα εισερχόμενά σας. Αν δεν φτάσει σε 3 λεπτά, ελέγξτε τον φάκελο ανεπιθύμητης αλληλογραφίας σας.",
    "If you have an account, an email has been sent to {submittedEmailOrInbox}. Click the link inside or enter your code below.": "",
    "If you would like to start receiving emails again, the best next steps are to check your email address on file for any issues and then click resubscribe on the previous screen.": "Αν θέλετε να αρχίσετε να λαμβάνετε ξανά emails, τα καλύτερα επόμενα βήματα είναι να ελέγξετε τη διεύθυνση email που έχετε καταχωρήσει για τυχόν προβλήματα και στη συνέχεια να κάνετε κλικ στην επανεγγραφή στην προηγούμενη οθόνη.",
    "If you're not receiving the email newsletter you've subscribed to, here are a few things to check.": "Αν δεν λαμβάνετε το ενημερωτικό δελτίο email στο οποίο έχετε εγγραφεί, εδώ είναι μερικά πράγματα που πρέπει να ελέγξετε.",
    "If you've completed all these checks and you're still not receiving emails, you can reach out to get support by contacting {supportAddress}.": "Αν έχετε ολοκληρώσει όλους αυτούς τους ελέγχους και εξακολουθείτε να μην λαμβάνετε emails, μπορείτε να επικοινωνήσετε με την υποστήριξη επικοινωνώντας με {supportAddress}.",
    "In the event a permanent failure is received when attempting to send a newsletter, emails will be disabled on the account.": "Σε περίπτωση που ληφθεί μόνιμη αποτυχία κατά την αποστολή ενός ενημερωτικού δελτίου, τα emails θα απενεργοποιηθούν στον λογαριασμό.",
    "In your email client add {senderEmail} to your contacts list. This signals to your mail provider that emails sent from this address should be trusted.": "Στον πελάτη email σας προσθέστε το {senderEmail} στη λίστα επαφών σας. Αυτό σηματοδοτεί στον πάροχο email σας ότι τα emails που αποστέλλονται από αυτήν τη διεύθυνση πρέπει να είναι αξιόπιστα.",
    "Invalid email address": "",
    "Invalid verification code": "",
    "Jamie Larson": "",
    "jamie@example.com": "",
    "Less like this": "Λιγότερο σαν αυτό",
    "LinkedIn": "",
    "Make sure emails aren't accidentally ending up in the Spam or Promotions folders of your inbox. If they are, click on \"Mark as not spam\" and/or \"Move to inbox\".": "Βεβαιωθείτε ότι τα emails δεν καταλήγουν κατά λάθος στους φακέλους Ανεπιθύμητη αλληλογραφία ή Προσφορές των εισερχομένων σας. Αν είναι εκεί, κάντε κλικ στο \"Σήμανση ως μη ανεπιθύμητη αλληλογραφία\" και/ή \"Μεταφορά στα εισερχόμενα\".",
    "Manage": "Διαχείριση",
    "Maybe later": "Ίσως αργότερα",
    "Membership details": "",
    "Memberships from this email domain are currently restricted.": "",
    "Memberships unavailable, contact the owner for access.": "Τα μέλη δεν είναι διαθέσιμα, επικοινωνήστε με τον ιδιοκτήτη για πρόσβαση.",
    "month": "",
    "Monthly": "Μηνιαία",
    "More like this": "Περισσότερα σαν αυτό",
    "More options": "",
    "Name": "Όνομα",
    "Need more help? Contact support": "Χρειάζεστε περισσότερη βοήθεια; Επικοινωνήστε με την υποστήριξη",
    "Newsletters can be disabled on your account for two reasons: A previous email was marked as spam, or attempting to send an email resulted in a permanent failure (bounce).": "Τα ενημερωτικά δελτία μπορούν να απενεργοποιηθούν στον λογαριασμό σας για δύο λόγους: Ένα προηγούμενο email επισημάνθηκε ως ανεπιθύμητο ή η προσπάθεια αποστολής email είχε ως αποτέλεσμα μόνιμη αποτυχία (αναπήδηση).",
    "No member exists with this e-mail address.": "",
    "No thanks, I want to cancel": "",
    "Not ready to share? We've also emailed a copy to your inbox.": "",
    "Not receiving emails?": "Δεν λαμβάνετε emails;",
    "Now check your email!": "Τώρα ελέγξτε το email σας!",
    "Occasional updates from {siteTitle}": "",
    "Once resubscribed, if you still don't see emails in your inbox, check your spam folder. Some inbox providers keep a record of previous spam complaints and will continue to flag emails. If this happens, mark the latest newsletter as 'Not spam' to move it back to your primary inbox.": "Μόλις εγγραφείτε ξανά, αν εξακολουθείτε να μην βλέπετε emails στα εισερχόμενά σας, ελέγξτε τον φάκελο ανεπιθύμητης αλληλογραφίας. Ορισμένοι πάροχοι εισερχομένων διατηρούν αρχείο προηγούμενων αναφορών ανεπιθύμητης αλληλογραφίας και θα συνεχίσουν να επισημαίνουν emails. Αν συμβεί αυτό, επισημάνετε το τελευταίο ενημερωτικό δελτίο ως 'Μη ανεπιθύμητο' για να το μετακινήσετε ξανά στα κύρια εισερχόμενά σας.",
    "Open AOL Mail": "",
    "Open email": "",
    "Open Feedbin": "",
    "Open Gmail": "",
    "Open Hey": "",
    "Open iCloud Mail": "",
    "Open Mail.ru": "",
    "Open Outlook": "",
    "Open Proton Mail": "",
    "Open Yahoo Mail": "",
    "Permanent failure (bounce)": "Μόνιμη αποτυχία (αναπήδηση)",
    "Phone number": "",
    "Plan": "Πρόγραμμα",
    "Plan checkout was cancelled.": "Η πληρωμή του προγράμματος ακυρώθηκε.",
    "Plan upgrade was cancelled.": "Η αναβάθμιση του προγράμματος ακυρώθηκε.",
    "Please contact {supportAddress} to adjust your complimentary subscription.": "Επικοινωνήστε με το {supportAddress} για να προσαρμόσετε τη δωρεάν συνδρομή σας.",
    "Please enter {fieldName}": "",
    "Please fill in required fields": "Συμπληρώστε τα απαιτούμενα πεδία",
    "Podcasts": "",
    "Re-enable emails": "Ενεργοποιήστε ξανά τα emails",
    "Recommendations": "Συστάσεις",
    "Redeem your membership": "",
    "Redeeming...": "",
    "Renews at {price}.": "Ανανεώνεται στα {price}.",
    "Resume subscription": "",
    "Retry": "Επανάληψη",
    "Save": "Αποθήκευση",
    "Save {amountOff} on your next {durationInMonths} billing cycles. Then {currency}{originalPrice}/{cadence}.": "",
    "Save {amountOff} on your next billing cycle. Then {currency}{originalPrice}/{cadence}.": "",
    "Send an email and say hi!": "Στείλτε ένα email και πείτε γεια!",
    "Send an email to {senderEmail} and say hello. This can also help signal to your mail provider that emails to and from this address should be trusted.": "Στείλτε ένα email στο {senderEmail} και πείτε γεια. Αυτό μπορεί επίσης να βοηθήσει να υποδείξει στον πάροχο email σας ότι τα emails προς και από αυτήν τη διεύθυνση πρέπει να είναι αξιόπιστα.",
    "Send the link below to share it with whoever you'd like.": "",
    "Sending login link...": "Αποστολή συνδέσμου σύνδεσης...",
    "Sending...": "Αποστολή...",
    "Share": "",
    "Share a full membership to {siteTitle} with a friend or colleague": "",
    "Show all": "Εμφάνιση όλων",
    "Sign in": "Σύνδεση",
    "Sign out": "Αποσύνδεση",
    "Sign up": "Εγγραφή",
    "Signup error: Invalid link": "Σφάλμα εγγραφής: Μη έγκυρος σύνδεσμος",
    "Signups from this email domain are currently restricted.": "",
    "Something went wrong, please try again later.": "",
    "Sorry, no paid plans are available.": "",
    "Sorry, no recommendations are available right now.": "",
    "Sorry, that didn’t work.": "Συγγνώμη, αυτό δεν λειτούργησε.",
    "Spam complaints": "Αναφορές ανεπιθύμητης αλληλογραφίας",
    "Start {amount}-day free trial": "Ξεκινήστε {amount}-ημερών δωρεάν δοκιμή",
    "Starting {startDate}": "Έναρξη {startDate}",
    "Starting today": "Ξεκινώντας σήμερα",
    "Submit feedback": "Υποβολή σχολίων",
    "Subscribe": "Εγγραφή",
    "Subscribed": "Εγγεγραμμένος",
    "Subscription plan updated successfully": "",
    "Success": "Επιτυχία",
    "Success! Check your email for magic link to sign-in.": "Επιτυχία! Ελέγξτε το email σας για να ολοκληρώσετε την εγγραφή.",
    "Success! Your account is fully activated, you now have access to all content.": "Επιτυχία! Ο λογαριασμός σας είναι πλήρως ενεργοποιημένος, έχετε πλέον πρόσβαση σε όλο το περιεχόμενο.",
    "Success! Your email is updated.": "Επιτυχία! Το email σας ενημερώθηκε.",
    "Successfully unsubscribed": "Επιτυχής διαγραφή από τη λίστα",
    "Thank you for subscribing. Before you start reading, below are a few other sites you may enjoy.": "Ευχαριστούμε που εγγραφήκατε. Πριν ξεκινήσετε να διαβάζετε, εδώ είναι μερικοί άλλοι ιστότοποι που μπορεί να σας αρέσουν.",
    "Thank you for your support": "",
    "Thank you for your support!": "",
    "Thanks for the feedback!": "Ευχαριστούμε για το σχόλιο!",
    "That didn't go to plan": "Αυτό δεν πήγε σύμφωνα με το σχέδιο",
    "The email address we have for you is {memberEmail} — if that's not correct, you can update it in your <button>account settings area</button>.": "Η διεύθυνση email που έχουμε για εσάς είναι {memberEmail} — αν δεν είναι σωστή, μπορείτε να την ενημερώσετε στην <button>περιοχή ρυθμίσεων λογαριασμού</button>.",
    "There was a problem submitting your feedback. Please try again a little later.": "Παρουσιάστηκε πρόβλημα κατά την υποβολή των σχολίων σας. Δοκιμάστε ξανά αργότερα.",
    "There was an error cancelling your subscription, please try again.": "",
    "There was an error continuing your subscription, please try again.": "",
    "There was an error processing your payment. Please try again.": "",
    "There was an error sending the email, please try again": "",
    "This gift has already been consumed.": "",
    "This gift has already been redeemed.": "",
    "This gift has been refunded.": "",
    "This gift has expired.": "",
    "This site is invite-only, contact the owner for access.": "Αυτός ο ιστότοπος είναι μόνο με πρόσκληση, επικοινωνήστε με τον ιδιοκτήτη για πρόσβαση.",
    "This site is not accepting donations at the moment.": "",
    "This site is not accepting payments at the moment.": "",
    "This site only accepts paid members.": "",
    "Threads": "",
    "Tier": "",
    "To complete signup, click the confirmation link in your inbox. If it doesn't arrive within 3 minutes, check your spam folder!": "Για να ολοκληρώσετε την εγγραφή, κάντε κλικ στον σύνδεσμο επιβεβαίωσης στα εισερχόμενά σας. Αν δεν φτάσει εντός 3 λεπτών, ελέγξτε τον φάκελο ανεπιθύμητης αλληλογραφίας!",
    "To continue to stay up to date, subscribe to {publication} below.": "",
    "Too many attempts try again in {number} days.": "",
    "Too many attempts try again in {number} hours.": "",
    "Too many attempts try again in {number} minutes.": "",
    "Too many different sign-in attempts, try again in {number} days": "",
    "Too many different sign-in attempts, try again in {number} hours": "",
    "Too many different sign-in attempts, try again in {number} minutes": "",
    "Too many sign-up attempts, try again later": "",
    "Try free for {amount} days, then {originalPrice}.": "Δοκιμάστε δωρεάν για {amount} ημέρες, μετά {originalPrice}.",
    "Unable to initiate checkout session": "",
    "Unlock access to all newsletters by becoming a paid subscriber.": "Ξεκλειδώστε την πρόσβαση σε όλα τα ενημερωτικά δελτία, ενεργοποιόντας την premium συνδρομή.",
    "Unsubscribe from all emails": "Διαγραφή από όλα τα emails",
    "Unsubscribed": "Διαγραμμένος",
    "Unsubscribed from all emails.": "Διαγραφή από όλα τα emails.",
    "Unsubscribing from emails will not cancel your paid subscription to {title}": "Η διαγραφή από τα emails δεν θα ακυρώσει την premium συνδρομή σας στο {title}",
    "Update": "Ενημέρωση",
    "Update your preferences": "Ενημερώστε τις προτιμήσεις σας",
    "Updates & announcements": "",
    "Verification link sent, check your inbox": "Ο σύνδεσμος επιβεβαίωσης έχει σταλεί, ελέγξτε τα εισερχόμενά σας",
    "Verify your email address is correct": "Επιβεβαιώστε ότι η διεύθυνση email σας είναι σωστή",
    "Verifying...": "",
    "View plans": "Προβολή προγραμμάτων",
    "We couldn't unsubscribe you as the email address was not found. Please contact the site owner.": "Δεν ήταν δυνατή η διαγραφή σας από τη λίστα επειδή η διεύθυνση email δεν βρέθηκε. Επικοινωνήστε με τον ιδιοκτήτη του ιστότοπου.",
    "We'd hate to see you leave. How about a special offer to stay?": "",
    "Welcome back, {name}!": "Καλώς ήρθατε ξανά, {name}!",
    "Welcome back!": "Καλώς ήρθατε ξανά!",
    "Welcome to {siteTitle}": "Καλώς ήρθατε στο {siteTitle}",
    "When an inbox fails to accept an email it is commonly called a bounce. In many cases, this can be temporary. However, in some cases, a bounced email can be returned as a permanent failure when an email address is invalid or non-existent.": "Όταν τα εισερχόμενα αποτυγχάνουν να αποδεχθούν ένα email, συνήθως ονομάζεται αναπήδηση. Σε πολλές περιπτώσεις, αυτό μπορεί να είναι προσωρινό. Ωστόσο, σε ορισμένες περιπτώσεις, ένα αναπηδήμένο email μπορεί να επιστραφεί ως μόνιμη αποτυχία όταν μια διεύθυνση email είναι άκυρη ή ανύπαρκτη.",
    "Why has my email been disabled?": "Γιατί έχει απενεργοποιηθεί το email μου;",
    "X (Twitter)": "",
    "year": "",
    "Yearly": "Ετήσια",
    "You already have an active subscription.": "",
    "You currently have a free membership, upgrade to a paid subscription for full access.": "Αυτή τη στιγμή έχετε δωρεάν μέλος, αναβαθμίστε σε premium συνδρομή για πλήρη πρόσβαση.",
    "You have been successfully resubscribed": "Έχετε εγγραφεί ξανά με επιτυχία",
    "You now have access to {tierName} until {expiryDate}. Enjoy!": "",
    "You're currently not receiving emails": "Αυτή τη στιγμή δεν λαμβάνετε emails",
    "You're not receiving emails": "Δεν λαμβάνετε emails",
    "You're not receiving emails because you either marked a recent message as spam, or because messages could not be delivered to your provided email address.": "Δεν λαμβάνετε emails επειδή είτε επισημάνατε ένα πρόσφατο μήνυμα ως ανεπιθύμητο είτε επειδή τα μηνύματα δεν μπόρεσαν να παραδοθούν στην παρεχόμενη διεύθυνση email σας.",
    "You've been gifted a membership": "",
    "You've been gifted a membership to {siteTitle}": "",
    "You've successfully signed in.": "Έχετε συνδεθεί επιτυχώς.",
    "You've successfully subscribed to <strong>{siteTitle}</strong>": "Έχετε εγγραφεί επιτυχώς στο <strong>{siteTitle}</strong>",
    "Your account": "Ο λογαριασμός σας",
    "Your email": "",
    "Your email has failed to resubscribe, please try again": "",
    "Your gift is ready": "",
    "Your gift subscription will expire on {expiryDate}": "",
    "your inbox": "",
    "Your input helps shape what gets published.": "Η συνεισφορά σας βοηθά να διαμορφωθεί το τι δημοσιεύεται.",
    "Your name": "",
    "Your subscription has been canceled and will expire on {expiryDate}.": "",
    "Your subscription will expire on {expiryDate}": "Η συνδρομή σας θα λήξει στις {expiryDate}",
    "Your subscription will renew on {renewalDate}": "Η συνδρομή σας θα ανανεωθεί στις {renewalDate}",
    "Your subscription will start on {subscriptionStart}": "Η συνδρομή σας θα ξεκινήσει στις {subscriptionStart}"
}
